import Vue from 'vue'
import Router from 'vue-router'

// pages
import ManualEntryPage from '../views/ManualEntryPage.vue';
import PageNotFound from '../views/PageNotFound.vue';
import ManualEntrySuccess from '../views/ManualEntrySuccess.vue';
import ManualEntryFailure from '../views/ManualEntryFailure.vue';
import Redirect from '../views/Redirect';
import AbstractAppPage from '../views/AbstractAppPage.vue';
import ImpressumPage from '../views/ImpressumPage.vue';
import IframeMapHolder from '../views/IframeMapHolder.vue';
import MapHolder from '../views/MapHolder.vue';
import AccessibilityDeclaration from '../components/AccessibilityDeclaration.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [{
    path: '/m/:portalUuid',
    component: AbstractAppPage,
    props: true,
    mode: 'abstract',
    children: [{
      path: 'success',
      component: ManualEntrySuccess,
      meta: {
        header: true,
        hero: true,
      }
    },
      {
        path: 'failure',
        component: ManualEntryFailure,
        meta: {
          header: true,
          hero: true,
        }
      },
      {
        path: '',
        component: ManualEntryPage,
        meta: {
          header: true,
          hero: true,
        }
      },
      {
        path: 'iframe/parcelshops',
        component: IframeMapHolder,
        meta: {
          header: false,
          hero: false,
        }
      },
      {
        path: 'parcelshops',
        component: MapHolder,
        meta: {
          header: true,
          hero: false,
        }
      },
    ]
  },
    {
      path: '/iframe/parcelshops',
      component: IframeMapHolder,
      meta: {
        header: false,
        hero: false,
      }
    },
    {
      path: '/parcelshops',
      component: MapHolder,
      meta: {
        header: true,
        hero: false,
      }
    },
    {
      path: '/hu/parcelshops',
      component: IframeMapHolder,
      name: 'hungaryMap',
      meta: {
        header: false,
        hero:false,
      }
    },
    {
      path: '/c/:portalUuid',
      component: AbstractAppPage,
      props: true,
      mode: 'abstract',
      children: [{
        path: 'impressum',
        component: ImpressumPage,
        meta: {
          header: true,
          hero: false,
        }
      },
        {
          path: '/c/:identifier/accessibility',
          name: 'Accessibility',
          component: AccessibilityDeclaration,
          meta: {
            header: true,
            hero: false,
          }
        },
        {
          path: '',
          component: PageNotFound,
          meta: {
            header: true,
            hero: false,
          }
        }
      ]
    },
    {
      path: '/',
      component: Redirect
    },
    {
      path: '*',
      component: AbstractAppPage,
      children: [{
        path: '',
        component: PageNotFound,
        meta: {
          header: true,
          hero: false,
        }
      }]
    }
  ]
})



// WEBPACK FOOTER //
// ./client/router/index.js